// assets
import { SecurityScanOutlined ,MenuOutlined, FieldTimeOutlined, EditFilled, ProfileOutlined, UserSwitchOutlined, OrderedListOutlined, MenuUnfoldOutlined,   ApartmentOutlined 
} from '@ant-design/icons';

// icons<FieldTimeOutlined />
const icons = {
  SecurityScanOutlined,
  MenuOutlined,
  MenuOutlined,
  FieldTimeOutlined,
  EditFilled,
  ProfileOutlined,
  UserSwitchOutlined,
  OrderedListOutlined,
  MenuUnfoldOutlined,
  ApartmentOutlined 
};  

// ==============================|| MENU ITEMS - IAM ||============================== //

const iam= {
  id: 'group-iam',
  title: 'IAM',
  type: 'collapse',
  icon: icons.SecurityScanOutlined,
  children: [
    {
      id: 'CompanyList',
      title: 'Company List',
      type: 'item',
      url: '/company',
      icon: icons.OrderedListOutlined,
      breadcrumbs: false
    },
     {
      id: "MenuList",
      title: "Menu Master",
      type: "item",
      url: "/menu",
      icon: icons.MenuOutlined,
    },
    {
      id: "SubmenuList",
      title: "Submenu Master",
      type: "item",
      url: "/submenu",
      icon: icons.MenuUnfoldOutlined,
    },
      {
      id: "AssignCompanyMenu",
      title: "Assign Company Menu",
      type: "item",
      url: "/assign-company-menu",
      icon: icons.ApartmentOutlined,
    },
      {
      id: "AssignRoleMenu",
      title: "Role-Wise Menu Access",
      type: "item",
      url: "/assign-role-menu",
      icon: icons.UserSwitchOutlined,
    },
  ]
};

export default iam;
